import { combineReducers } from 'redux';
import loginReducer from './reducers/login.reducer';

const globalReducer = combineReducers({
    userinfo: loginReducer,
});

export default globalReducer;
